/**
 * @module mapbs.components.about.about
 */

import './about.scss';

import angular from 'angular';

const moduleAbout = angular.module('mapbsAboutModule', []);

moduleAbout.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/about', require('./about.html'));
    }
);

/**
 * @type {!angular.Component}
 */
const aboutComponent = {
    controller: 'mapbsAboutController as aboutCtrl',
    bindings: {
        'brandImage': '@mapbsAboutBrandImage',
        'addressList': '<mapbsAboutAddresslist',
    },
    templateUrl: () => 'mapbs/about',
};

moduleAbout.component('mapbsAbout', aboutComponent);

/**
 * @typedef {Object} Information
 * @property {string} text
 * @property {string} url
 */

/**
 * @typedef {Object} OfficeHour
 * @property {string} day
 * @property {string} morning
 * @property {string} afternoon
 */

/**
 * @typedef {Object} Address
 * @property {string} type
 * @property {string[]} contact
 * @property {string} street
 * @property {string} city
 * @property {string} phone
 * @property {string} email
 * @property {string} web
 * @property {Information[]} info
 * @property {OfficeHour[]} officehours
 */

class AboutController {
    /**
   * @constructor
   * @private
   * @ngInject
   */
    constructor() {
    /**
     * @type {string}
     */
        this.brandImage;

        /**
     * @type {Address[]}
     */
        this.addressList;
    }
}

moduleAbout.controller('mapbsAboutController', AboutController);

export default moduleAbout;
